<template>
  <router-link :to="{name: 'BackendUserContractFlow'}"
               :class="{mdButton: isButton}"
               :tag="tagClass()">
    <span :class="{'md-list-item-text': !isButton}">{{ label }}</span>
    <md-icon>arrow_right</md-icon>
  </router-link>
</template>

<script>
export default {
  name   : 'ToContractButton',
  props  : {
    isButton: {
      type   : Boolean,
      default: true,
    },
    label   : {
      type   : String,
      default: '本契約の手続き',
    }
  },
  methods: {
    tagClass() {
      return this.isButton ? 'md-button' : 'md-list-item';
    }
  }
}
</script>

<style lang="scss" scoped>
.md-button.md-theme-default {
  background-color: orange;
  color: rgba(255, 255, 255, 1);
  color: var(--md-theme-default-text-primary-on-background, rgba(255, 255, 255, 1));
}

.md-list-item {
  background-color: orange;
}

.md-list-item-text {
  color: rgba(255, 255, 255, 1);
  color: var(--md-theme-default-text-primary-on-background, rgba(255, 255, 255, 1));
}

.md-toolbar.md-theme-default.md-transparent .md-icon,
.md-icon.md-theme-default.md-icon-font {
  color: rgba(255, 255, 255, 1);
  color: var(--md-theme-default-text-primary-on-background, rgba(255, 255, 255, 1));
}
</style>
